export default function isFileAllowed( filename ){
  const allowed_formats = ['jpg', 'jpeg', 'pdf', 'mq5']
  let file_extension = filename.split('.').pop()

  return allowed_formats.includes(file_extension)
}